import type { VNodeRef } from "vue";

export const useUIStore = defineStore('uiStore', () => {
  const bodyRef = ref(document?.body);
  const bodyScrollLock = useScrollLock(bodyRef);
  const navRef : VNodeRef = ref(undefined);
  const { width: navWidth, height: navHeight } = useElementSize(navRef);

  function scrollLockBody(locked: boolean) {
    bodyScrollLock.value = locked;
  }

  return { 
    scrollLockBody,
    navRef,
    navWidth,
    navHeight
  };
});